export const GIFT_GUIDE_CONTENT = {
  breadcrumb: 'Gift Guide',
  title: 'Find the Perfect Gift',
  subtitle:
    "Whether it's a birthday, holiday, or just because - we have the perfect cuddly companion for every precious moment.",
  occasions: {
    title: 'Shop by Occasion',
    items: [
      {
        title: 'Baby Shower',
        icon: 'Baby',
        color: 'bg-primary-50 text-primary-600',
        description: 'Soft, safe companions for the newest addition to the family.',
        products: ['Mini Bunnies', 'Sensory Toys', 'Security Blankets'],
        path: '/shop?category=baby',
      },
      {
        title: 'Birthday',
        icon: 'Gift',
        color: 'bg-primary-50 text-primary-600',
        description: 'Make their special day even more memorable with a big surprise.',
        products: ['Teddy Bears', 'Unicorns', 'Personalized Toys'],
        path: '/shop?category=birthday',
      },
      {
        title: "Valentine's",
        icon: 'Heart',
        color: 'bg-primary-50 text-primary-600',
        description: 'Show your love with a cuddly friend that speaks from the heart.',
        products: ['Heart-shaped Toys', 'Love Bears', 'Couple Sets'],
        path: '/shop?category=valentine',
      },
      {
        title: 'Christmas',
        icon: 'Sparkles',
        color: 'bg-primary-50 text-primary-600',
        description: 'The perfect stocking stuffer or under-the-tree surprise.',
        products: ['Santa Bears', 'Reindeer', 'Holiday Collection'],
        path: '/shop?category=christmas',
      },
    ],
  },
  byAge: {
    title: 'Gifts by Age',
    items: [
      {
        age: '0-1 years',
        title: 'Newborn Cuddles',
        desc: 'Soft, sensory-friendly toys',
        color: 'bg-purple-50 border-purple-100',
        textColor: 'text-purple-600',
      },
      {
        age: '1-3 years',
        title: 'First Friends',
        desc: 'Durable and washable',
        color: 'bg-secondary-50 border-secondary-100',
        textColor: 'text-secondary-600',
      },
      {
        age: '3-5 years',
        title: 'Preschool Pals',
        desc: 'Imaginative play companions',
        color: 'bg-secondary-50 border-secondary-100',
        textColor: 'text-secondary-600',
      },
      {
        age: '5+ years',
        title: 'Forever Friends',
        desc: 'Collectible and huggable',
        color: 'bg-teal-50 border-teal-100',
        textColor: 'text-teal-600',
      },
    ],
  },
  services: [
    {
      icon: 'Gift',
      title: 'Gift Wrapping',
      desc: 'Beautiful premium wrapping and personalized cards at checkout.',
      color: 'bg-primary-50 text-primary-500',
    },
    {
      icon: 'Calendar',
      title: 'Scheduled Delivery',
      desc: 'Choose the perfect arrival date for birthdays and special moments.',
      color: 'bg-blue-50 text-blue-500',
    },
    {
      icon: 'Star',
      title: 'Personalization',
      desc: 'Add names or special messages with our premium embroidery service.',
      color: 'bg-purple-50 text-purple-500',
    },
  ],
} as const;
